export const RequestAccessType = {
  SEAT: 'SEAT',
  PERMISSION: 'PERMISSION'
};